@if (countryCode(); as countryCode) {
  <div class="country-cell">
    <onyx-flag
      [countryCode]="countryCode"
      [size]="size()"
      [showTooltip]="!onlyFlag()"
    ></onyx-flag>

    @if (!onlyFlag()) {
      <p>
        @if (short()) {
          {{ countryCode | uppercase }}
        } @else {
          {{ `${DictionaryCode.COUNTRY}.${countryCode}` | translate }}
        }
      </p>
    }
  </div>
} @else {
  -
}
